import { useInView } from '../../../hooks/useInView';

export default function Industries() {
  const { ref, inView } = useInView();

  const industries = [
    {
      title: 'Medical & Dental Practices',
      description: 'Patient intake automation, appointment optimization, and reputation intelligence — designed with compliance and discretion.',
      image: 'https://public.readdy.ai/ai/img_res/2662d0971004ea8decf1df99e088fb8a.jpg',
      stat: 'Avg. 40% faster intake',
    },
    {
      title: 'Home Improvement & Service Providers',
      description: 'Lead qualification, dispatch optimization, follow-up systems, and revenue visibility frameworks.',
      image: 'https://readdy.ai/api/search-image?query=Pristine%20modern%20home%20renovation%20in%20progress%20with%20clean%20professional%20workmanship%2C%20high-end%20residential%20interior%20transformation%2C%20polished%20tools%20and%20materials%20arranged%20neatly%2C%20beautiful%20natural%20light%20streaming%20through%20windows%2C%20craftsmanship%20and%20quality%20focus%2C%20architectural%20photography%20with%20warm%20tones%2C%20no%20people%20present&width=900&height=700&seq=ind-home-001&orientation=landscape',
      stat: 'Avg. 2x close rate',
    },
    {
      title: 'Legal & Financial Professionals',
      description: 'Secure intake pipelines, document workflows, client communication automation, and operational clarity systems.',
      image: 'https://readdy.ai/api/search-image?query=Sophisticated%20modern%20law%20firm%20or%20financial%20advisory%20office%20interior%20with%20elegant%20dark%20wood%20paneling%2C%20leather%20furnishings%2C%20premium%20bookshelf%20with%20legal%20volumes%2C%20warm%20library%20lighting%2C%20minimalist%20desk%20setup%2C%20prestigious%20professional%20environment%2C%20no%20people%2C%20rich%20dark%20tones%20with%20golden%20accents%2C%20architectural%20photography&width=900&height=700&seq=ind-legal-001&orientation=landscape',
      stat: 'Avg. 35% less admin time',
    },
    {
      title: 'Small & Local Businesses',
      description: 'Modern automation frameworks without enterprise complexity — tailored to your scale and ambitions.',
      image: 'https://readdy.ai/api/search-image?query=Charming%20modern%20boutique%20small%20business%20storefront%20with%20clean%20contemporary%20design%2C%20stylish%20product%20display%2C%20warm%20inviting%20ambiance%20with%20carefully%20curated%20interior%2C%20polished%20wood%20and%20white%20surfaces%2C%20professional%20retail%20aesthetic%2C%20natural%20daylight%2C%20no%20people%2C%20sophisticated%20local%20business%20atmosphere&width=900&height=700&seq=ind-local-001&orientation=landscape',
      stat: 'Enterprise tools, local scale',
    },
  ];

  return (
    <section id="industries" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`text-center mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-600 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Expertise</p>
          <h2 className="font-serif text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
            Specialized for High-Trust<br />Service Industries.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {industries.map((ind, i) => (
            <div
              key={i}
              className={`relative group overflow-hidden rounded-2xl cursor-pointer transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={ind.image}
                  alt={ind.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/30 to-transparent" />
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="inline-block bg-teal-500/20 text-teal-300 text-xs px-3 py-1 rounded-full tracking-wider mb-3 backdrop-blur-sm">
                  {ind.stat}
                </div>
                <h3 className="font-bold text-xl text-white mb-2">{ind.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed max-h-0 overflow-hidden group-hover:max-h-20 transition-all duration-500">
                  {ind.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
